<template>
    <div class="juhL-news" v-if="newsList">
        <div class="juhL-tit fb"><span class="fl">新闻资讯</span><span class="fr"><a :href="'//artso.artron.net/news/search_newslist.php?keyword='+organName" target="_blank">更多</a></span></div>

        <ul class="juhL-news-list">
            <li v-for="(item,i) in newsList" :key="i">
                <a :href="item.link" target="_blank">{{item.title}}</a><span>{{item.publish_at}}</span>
            </li>
        </ul>

    </div>
</template>

<script>
import {getOrgNews} from "@/api/brand";

export default {
    name: "OrgName",
    props:['organName'],
    data(){
        return{
            newsList:[],
            organ_name:''
        }
    },
    watch:{
        'organName':function (newValue){
            if(newValue){
                this.organ_name = newValue
                this.getOrgNews(newValue)
            }
        }
    },
    methods:{
        getOrgNews(name){
            let params = {
                name:name
            }
            getOrgNews(params).then((res) => {
                if(res.code == 0){
                    this.newsList = res.data.news_list
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.juhL-tit{
    height: 34px;
    margin-top: 10px;
    padding-left: 15px;
    line-height: 34px;
    font-size: 14px;
    color: #ffffff;
    background: #488ad4;
    font-weight: bold;
    font-family: SimSun;
}
.juhL-tit .fr a {
    padding-right: 10px;
    color: #ffffff;
    font-size: 12px;
    font-weight: normal;
}
.juhL-tit .fr a:hover{
    text-decoration: underline;
}
.juhL-news-list {
    padding: 14px 0px 14px;
    font-family: SimSun;
}
.juhL-news-list li {
    height: 26px;
    padding-left: 10px;
    line-height: 26px;
    vertical-align: top;
}
.juhL-news-list a {
    float: left;
    font-size: 14px;
    color: #152f7a;
    display:inline-block;
    max-width: 470px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.juhL-news-list a:hover{text-decoration: underline}
.juhL-news-list span {
    float: right;
    color: #858585;
    font-size: 12px;
}
</style>